export default {
  setUserSources(state, value) {
    state.userSource = value
  },
}
